import { render, staticRenderFns } from "./programBatchTermSchedules.vue?vue&type=template&id=35f8b100"
import script from "./programBatchTermSchedules.vue?vue&type=script&lang=js"
export * from "./programBatchTermSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports